import { ReactionType } from "@/src/models/post.model";
import React, { useRef } from "react";
import { Animated, Platform, Pressable } from "react-native";

type ReactionItemProps = Readonly<{
  id: ReactionType;
  emoji: string;
  onSelect: (reaction: ReactionType) => void;
}>;

const ReactionItem = ({ id, emoji, onSelect }: ReactionItemProps) => {
  const scale = useRef(new Animated.Value(1)).current;

  const animateIn = () => {
    Animated.spring(scale, {
      toValue: 1.3,
      useNativeDriver: true,
      friction: 5,
    }).start();
  };

  const animateOut = () => {
    Animated.spring(scale, {
      toValue: 1,
      useNativeDriver: true,
      friction: 5,
    }).start();
  };

  return (
    <Pressable
      onPress={() => onSelect(id)}
      onPressIn={animateIn}
      onPressOut={animateOut}
      {...(Platform.OS === "web"
        ? {
            onHoverIn: animateIn,
            onHoverOut: animateOut,
          }
        : {})}
      className="px-2 hover:rounded-full hover:bg-ash-3"
    >
      <Animated.Text
        style={{
          fontSize: 20,
          transform: [{ scale }],
        }}
      >
        {emoji}
      </Animated.Text>
    </Pressable>
  );
};

export default ReactionItem;
